import React from "react";
import AddPodcasts from "../../Administrative/AddPodcasts";

const AddYuvasarthiPodcasts = () => {
  return (
    <div>
      <AddPodcasts role="Super Admin" />
    </div>
  );
};

export default AddYuvasarthiPodcasts;
